import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/697c564d921dc90014549022/cyprus_diving/src/app/musan-underwater-museum-cyprus/page.tsx");
